import { AlarmClock, DoorOpen, FileCheck2, MessageSquareText, PhoneCall, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const items = [
  {
    icon: FileCheck2,
    title: "Forms before entry",
    body: "Every attendee accepts the current waiver and health forms in the booking system before visiting — no forms, no entry.",
  },
  {
    icon: ShieldCheck,
    title: "Safety checkout",
    body: "Sessions outside weekday staffed hours (6am–6pm) include the safety checkout, so we know you finished safe.",
  },
  {
    icon: MessageSquareText,
    title: "Finished-and-safe text",
    body: "A safety link arrives by text 2 minutes before your session ends. Select Y once you're finished and safe — or N immediately if you need help.",
  },
  {
    icon: AlarmClock,
    title: "If you don't respond",
    body: "No response by 15 minutes after your session ends alerts our nominated responders, who follow up.",
  },
  {
    icon: DoorOpen,
    title: "Exits always open",
    body: "Internal exits are always manually openable — you're never locked in. The alarm buttons beside the sauna and ice bath sound at front reception only. They do not call 000 or alert anyone offsite.",
  },
  {
    icon: PhoneCall,
    title: "Emergencies: call 000",
    body: "In any emergency, call 000 first. Reception alarms sound locally only — they do not call offsite responders.",
  },
];

const Safety = () => {
  return (
    <section id="safety" data-testid="safety-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <SectionHeading
            overline="Safety & responsible use"
            title={
              <>
                Relaxed, not <em className="italic text-ember">reckless.</em>
              </>
            }
          />
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06}>
              <div
                data-testid={`safety-item-${i + 1}`}
                className="h-full border border-line bg-clay p-7 hover:border-stone2 transition-colors duration-500"
              >
                <item.icon className="h-5 w-5 text-ember" aria-hidden="true" />
                <h3 className="mt-5 text-lg font-medium text-cream">{item.title}</h3>
                <p className="mt-2 text-sm font-light leading-relaxed text-sand">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p data-testid="safety-fee-note" className="mt-10 max-w-3xl text-xs leading-relaxed text-stone2">
            A documented unnecessary site visit may incur a A$250 fee after
            individual review by our staff — silence alone never automatically
            charges a fee. The venue operates unattended outside weekday staffed
            hours; it is not continuously monitored, and the safety checkout is a
            check-in system, not a guarantee of rescue. Follow the instructions at
            each station and listen to your body.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Safety;
